var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',[_c('v-col',[_c('v-card',{attrs:{"dark":""}},[_c('v-card-actions',[_c('v-select',{attrs:{"label":"Select season","value":_vm.season,"items":_vm.items},on:{"change":_vm.onChange}})],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }